import { t } from 'i18next'

import { ADS_STATUSES, CAPMPAIGNS_FILTERS_KEYS } from '../constants'

export const adsStatusFilter = {
  keyState: CAPMPAIGNS_FILTERS_KEYS.adStatus,
  placeholder: t('rm:filterByAdsStatus'),
  options: ADS_STATUSES
} as GenericFilterProps
